import { cn } from "@/lib/utils";
import type { SaveStatus } from "@/hooks/use-auto-save";

interface SaveIndicatorProps {
  status: SaveStatus;
  className?: string;
}

export function SaveIndicator({ status, className }: SaveIndicatorProps) {
  if (status === "idle") return null;

  return (
    <span
      className={cn(
        "text-xs transition-opacity",
        status === "saving" && "text-[hsl(var(--muted-foreground))]",
        status === "saved" && "text-[hsl(var(--accent))]",
        status === "error" && "text-[hsl(var(--destructive))]",
        className,
      )}
    >
      {status === "saving" && "Saving..."}
      {status === "saved" && "Saved"}
      {status === "error" && "Error saving"}
    </span>
  );
}
